import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import NotificationType from 'flarum/forum/components/NotificationType';
import Discussion from 'flarum/common/models/Discussion';
import Link from 'flarum/common/components/Link';
function toastDiscussion(notification) {
  const subject = notification.subject();
  if (!subject) return null;
  if (subject instanceof Discussion) return subject;
  if (typeof subject.discussion === 'function') {
    return subject.discussion() ?? null;
  }
  return null;
}

/**
 * Renders the stack of realtime notification toasts in the top-right corner.
 * Each toast wraps the standard NotificationType component (same as the dropdown),
 * with the related discussion title shown as context above it.
 */
export default class NotificationToast extends Component {
  view() {
    const toasts = this.attrs.state.all();
    if (!toasts.length) return null;
    return m("div", {
      className: "NotificationToasts",
      "aria-live": "polite",
      "aria-label": app.translator.trans('core.forum.notifications.title')
    }, toasts.map(entry => {
      const discussion = toastDiscussion(entry.notification);
      return m("div", {
        key: entry.id,
        className: "NotificationToast",
        onclick: () => this.attrs.state.dismiss(entry.id)
      }, discussion && m("div", {
        className: "NotificationToast-context"
      }, m(Link, {
        href: app.route.discussion(discussion)
      }, discussion.title())), m(NotificationType, {
        notification: entry.notification
      }));
    }));
  }
}
flarum.reg.add('flarum-realtime', 'forum/components/NotificationToast', NotificationToast);